import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import CountrySelect from '../../../common/forms/select/CountrySelect';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';

export const BankForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Codigo SWIFT" required>
          <Field
            name="swiftCode"
            component={TextInput}
            type="text"
            placeholder="Codigo SWIFT"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="País" required>
          <Field
            name="countryId"
            component={CountrySelect}
            validate={[isRequired]}
            placeholder="Ingresa mínimo 4 caracteres"
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Bank.getIn(['current', 'activity']).isEmpty(),
});

BankForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BankForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'BankForm',
})(BankForm);

export default connect(mapStateToProps)(formComponent);
